import {normalizeColor} from "../../../ts/common/SiteHelper";
import * as React from "react";
import {IMapMarkerIconProps, MapMarkerIconInstance} from "./MapMarkerIcon";
import {Point} from "maplibre-gl";
import {mapCoreConfig} from "../config/MapCoreConfig";

export interface IMapClusterIconProps extends IMapMarkerIconProps
{
    itemCount?:number;
    getColor?:((itemCount:number) => string|null)|string;
    getStrokeColor?:((itemCount:number) => string|null)|string;
    getTextColor?:((itemCount:number) => string|null)|string;
    getItemCountAbbreviated?:(itemCount:number) => string|null;
}

export class MapClusterIconInstance extends MapMarkerIconInstance
{
    props: IMapClusterIconProps;

    defaultSize:[number, number] = [58, 58]

    itemCount:number = 0;
    itemCountAbbreviated:string = "";
    textColor:string = "";

    constructor(props: IMapClusterIconProps)
    {
        super(props);
        this.props = props;
    }

    applyNextProps(nextProps:IMapClusterIconProps, props?:IMapClusterIconProps)
    {

        super.applyNextProps(nextProps, props);

        this.itemCount = nextProps.itemCount ?? 0;

        const clusterIconConfig:IMapClusterIconProps|null = mapCoreConfig.cluster?.clusterIcon ?? null
        const getColor:((itemCount:number) => string|null)|string|null = this.props.getColor ?? (clusterIconConfig?.getColor ?? null);
        const getStrokeColor:((itemCount:number) => string|null)|string|null = this.props.getStrokeColor ?? (clusterIconConfig?.getStrokeColor ?? null);
        const getTextColor:((itemCount:number) => string|null)|string|null = this.props.getTextColor ?? (clusterIconConfig?.getTextColor ?? null);
        const getItemCountAbbreviated:((itemCount:number) => string|null)|null = this.props.getItemCountAbbreviated !== undefined ? this.props.getItemCountAbbreviated : (clusterIconConfig?.getItemCountAbbreviated ?? null);

        const notFoundColor =  "#FFFFFF";
        this.color = this.getColourValue(getColor, this.itemCount) ?? notFoundColor;
        this.strokeColor = this.getColourValue(getStrokeColor, this.itemCount) ?? notFoundColor;
        this.textColor = this.getColourValue(getTextColor, this.itemCount) ?? notFoundColor;

        this.itemCountAbbreviated = (getItemCountAbbreviated ? getItemCountAbbreviated(this.itemCount) : null) ?? this.itemCount.toString();
    }

    getColourValue(from:string|((itemCount:number) => string|null)|undefined|null, itemCount:number): string|null
    {
        let value;
        if(typeof from === 'function' ){
            value = from(itemCount);
        } else {
            value = from;
        }
        return normalizeColor(value);
    }

    getOrigin():Point|null
    {
        return null;
    }

    getInternalOrigin():Point|null
    {
        return null;
    }

    getTopLeftAdditionalOffset():Point|null
    {
        return new Point(9, 9);
    }

    getBottomRightAdditionalOffset():Point|null
    {
        return new Point(-9, -9);
    }

    renderComponent()
    {
        const sizeWidth = this.size[0];
        const sizeHeight = this.size[1];
        const standardSizeWidth = this.standardSize[0];
        const standardSizeHeight = this.standardSize[1];
        return <div>

            <svg display="block" width={sizeWidth+"px"} height={sizeHeight+"px"} viewBox={"0 0 "+ standardSizeWidth +" "+standardSizeHeight}>
                <g fillRule="nonzero">
                    <g className="icon" transform="translate(29.0, 29.0)">
                        <ellipse style={{
                            strokeMiterlimit: 14,
                            strokeLinejoin: "round",
                            strokeWidth: 4,
                            paintOrder: "stroke markers",
                            strokeLinecap: "round",
                            fill: this.color,
                            stroke: this.strokeColor,
                            strokeOpacity: 0.6
                        }} rx="18" ry="18" />
                        <text x="0" y="0" style={{fill: this.textColor}} textAnchor="middle" dy=".34em" fontSize="0.8em">{this.itemCountAbbreviated}</text>
                    </g>
                </g>
            </svg>
        </div>
    }
}

const MapClusterIcon  = React.memo(MapClusterIconInstance);
export default MapClusterIcon;